module.exports = __webpack_public_path__ + "static/img/aboutUs_1.46925a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/aboutUs_1.png
// module id = lHEu
// module chunks = 1